/**
 * Cura — Doctor Voices modal
 * Opens the video modal on button click; injects the video markup only then
 * (so it doesn't load until requested) and removes it on close (stops playback).
 * Accessible: Esc to close, click-outside, focus return, body scroll lock.
 */
(function () {
  'use strict';

  class CuraDoctorVoices {
    constructor(section) {
      this.section = section;
      this.openBtn = section.querySelector('[data-dv-open]');
      this.modal = section.querySelector('[data-dv-modal]');
      if (!this.openBtn || !this.modal) return;

      this.holder = this.modal.querySelector('[data-dv-video-holder]');
      this.template = this.modal.querySelector('[data-dv-video-template]');
      this.closers = Array.from(this.modal.querySelectorAll('[data-dv-close]'));
      this.lastFocused = null;

      this.bind();
    }

    bind() {
      this.openBtn.addEventListener('click', () => this.open());
      this.closers.forEach((el) => el.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.modal.hidden) this.close();
      });
    }

    open() {
      this.lastFocused = document.activeElement;
      // Inject video markup from the template (loads/plays only now).
      if (this.template && !this.holder.querySelector('video, iframe')) {
        this.holder.appendChild(this.template.content.cloneNode(true));
      }
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const closeBtn = this.modal.querySelector('.cura-dv__modal-close');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
      // Remove the video node so playback (and audio) fully stops.
      const media = this.holder.querySelector('video, iframe');
      if (media) media.remove();
      if (this.lastFocused) this.lastFocused.focus();
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.cura-dv').forEach(function (el) {
      if (!el.dataset.dvInit) {
        new CuraDoctorVoices(el);
        el.dataset.dvInit = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();